import apiCall from "../apiCall/apiCall"
import { 
    CHANGE_SEARCH_FIELD,
    CATS_INFO_FETCHED,
    CATS_INFO_FETCH_ERROR,
} from "./constants"

export const setSearchField = (text) => ({ 
    type: CHANGE_SEARCH_FIELD, 
    payload: text
})

export const setCatsList = () => (dispatch) => { 
    apiCall('https://jsonplaceholder.typicode.com/users')
    .then(data => typeof data === 'object' && Object.keys(data).length === 0 ? [] : data)
    .then(cats => dispatch({type: CATS_INFO_FETCHED, payload: cats}))
    .catch( e => dispatch({type: CATS_INFO_FETCH_ERROR, error: e.message}))
}


